const PRODUCTION_API = 'https://place-yout-job-be-ccqvq.ondigitalocean.app/'

// Override at build time with REACT_APP_API_URL (e.g. http://localhost:8080/ for local development).
const configured = process.env.REACT_APP_API_URL
export const REST_API_BASE_URL_REMOTE = configured ? configured.replace(/\/?$/, '/') : PRODUCTION_API
export const REST_API_BASE_URL_REMOTE2 = 'http://localhost:8080/'
